import React from "react";
import PageShell from "@/components/PageShell";
import About from "@/components/About";

export default function AboutPage() {
    return (
        <PageShell>
            <About />
        </PageShell>
    );
}
